module.exports = __webpack_public_path__ + "img/pic_Lienchiang.9581667d.jpg";